import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Note, Ticket } from "../types";
import { fetchUserTickets } from "../api";
import { GlobalContext } from "../App";
import cardStyles from "../styles/Card.module.css";
import buttonStyles from "../styles/Button.module.css";

export default function PreviousTickets(currentTicket:Ticket) {
    const {globalSite} = useContext(GlobalContext);
    const [tickets, setTickets] = useState<Ticket[] | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (tickets === null) {
            fetchUserTickets(currentTicket.userName, globalSite).then(setTickets)
        }
    }, [currentTicket, globalSite, tickets]);

    function displayDateTime(datetime:string) {
        let dt = datetime.split('T')
        return dt[0] + " " + dt[1].split('.')[0]
    }
    
    function displayClosedTime(closedAt:string | undefined) {
        if (!closedAt) {
            return null
        } else {
            return "Closed: " + closedAt.split('T')[0]
        }
    }

    function displayStatus(status:string) {
        switch (status) {
            case "Requested":
                return <span className={buttonStyles.statusOpen}>Open</span>;
            case "InProgress":
                return <span className={buttonStyles.statusInProgress}>In Progress</span>;
            case "EscalatedToUnify":
                return <span className={buttonStyles.statusEscalated}>Escalated</span>;
            case "Closed":
                return <span className={buttonStyles.statusClosed}>Closed</span>;
            default:
                return null;
        }
    }

    function displayPreviousTicket(ticket:Ticket) {
        if (ticket.id === currentTicket.id) {
            return null
        }
        return (
            <div
            onClick={() => navigate(`/dashboard/${globalSite}/support/${ticket.id}`)}
                key={ticket.id}
                className={cardStyles.card}
                style={{
                    display: "flex",
                    justifyContent: "space-between"
                }}
            >
                <div>{displayDateTime(ticket.requested)}</div>
                <div>Faults: {ticket.faults.length}</div>
                <div>Notes: {ticket.notes.length}</div>
                <div>{displayClosedTime(ticket.closed)}</div>
                <div>{displayStatus(ticket.status)}</div>
            </div>
        )
    }

    if (tickets === null) {
        return null
    }

    return (
        <div className={cardStyles.card}>
            <h2>Previous Tickets</h2>
            {tickets.map(t => 
                displayPreviousTicket(t)
            )}
        </div>
    )
}
